import React from 'react';
import { Container } from './ui/Container';
import { Check, X } from 'lucide-react';
export function DifferentiationSection() {
  return <section className="bg-white pb-20" data-id="element-45">
      {/* Lifestyle Banner */}
      <div className="w-full h-[300px] relative mb-16 overflow-hidden" data-id="element-46">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-47"></div>
        <img src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=800&q=80" alt="Couple hugging in bed" className="w-full h-full object-cover" data-id="element-48" />
        <div className="absolute inset-0 flex items-center justify-center z-20 text-center px-4" data-id="element-49">
          <h2 className="text-3xl md:text-5xl font-bold text-white drop-shadow-lg" data-id="element-50">
            Why SnoreStop™ Beats Everything Else
          </h2>
        </div>
      </div>

      <Container data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <div className="max-w-2xl mx-auto space-y-3 text-left bg-gray-50 p-6 rounded-2xl border border-gray-100" data-id="element-53">
            {['Works from the first night', 'No machines, wires or noise', 'Comfortable and moldable', 'One-time purchase', 'Relationship-saving results'].map((reason, i) => <div key={i} className="flex items-center text-lg" data-id="element-54">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-55" />
                <span className="font-medium text-gray-800" data-id="element-56">{reason}</span>
              </div>)}
          </div>
        </div>

        <div className="overflow-x-auto mb-16" data-id="element-57">
          <table className="w-full max-w-5xl mx-auto border-collapse shadow-xl rounded-2xl overflow-hidden" data-id="element-58">
            <thead data-id="element-59">
              <tr className="bg-gray-900 text-white" data-id="element-60">
                <th className="p-6 text-left font-bold text-lg" data-id="element-61">Feature</th>
                <th className="p-6 text-center bg-blue-600 font-bold text-xl relative" data-id="element-62">
                  SnoreStop™
                  <div className="absolute top-0 left-0 w-full h-1 bg-green-400" data-id="element-63"></div>
                </th>
                <th className="p-6 text-center font-medium text-gray-300" data-id="element-64">
                  Nose Strips
                </th>
                <th className="p-6 text-center font-medium text-gray-300" data-id="element-65">
                  Sprays
                </th>
                <th className="p-6 text-center font-medium text-gray-300" data-id="element-66">
                  CPAP
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white" data-id="element-67">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-68">
                <td className="p-4 font-semibold text-gray-900 border-r border-gray-100" data-id="element-69">
                  Reduces snoring
                </td>
                <td className="p-4 text-center bg-blue-50 border-x-2 border-blue-100" data-id="element-70">
                  <Check className="w-6 h-6 text-green-500 mx-auto stroke-[3px]" data-id="element-71" />
                </td>
                <td className="p-4 text-center" data-id="element-72">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-73" />
                </td>
                <td className="p-4 text-center" data-id="element-74">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-75" />
                </td>
                <td className="p-4 text-center" data-id="element-76">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-77" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-78">
                <td className="p-4 font-semibold text-gray-900 border-r border-gray-100" data-id="element-79">
                  Comfortable
                </td>
                <td className="p-4 text-center bg-blue-50 border-x-2 border-blue-100" data-id="element-80">
                  <Check className="w-6 h-6 text-green-500 mx-auto stroke-[3px]" data-id="element-81" />
                </td>
                <td className="p-4 text-center" data-id="element-82">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-83" />
                </td>
                <td className="p-4 text-center" data-id="element-84">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-85" />
                </td>
                <td className="p-4 text-center" data-id="element-86">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-87" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-88">
                <td className="p-4 font-semibold text-gray-900 border-r border-gray-100" data-id="element-89">
                  Silent
                </td>
                <td className="p-4 text-center bg-blue-50 border-x-2 border-blue-100" data-id="element-90">
                  <Check className="w-6 h-6 text-green-500 mx-auto stroke-[3px]" data-id="element-91" />
                </td>
                <td className="p-4 text-center" data-id="element-92">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-93" />
                </td>
                <td className="p-4 text-center" data-id="element-94">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-95" />
                </td>
                <td className="p-4 text-center" data-id="element-96">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-97" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-98">
                <td className="p-4 font-semibold text-gray-900 border-r border-gray-100" data-id="element-99">
                  Travel-friendly
                </td>
                <td className="p-4 text-center bg-blue-50 border-x-2 border-blue-100" data-id="element-100">
                  <Check className="w-6 h-6 text-green-500 mx-auto stroke-[3px]" data-id="element-101" />
                </td>
                <td className="p-4 text-center" data-id="element-102">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-103" />
                </td>
                <td className="p-4 text-center" data-id="element-104">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-105" />
                </td>
                <td className="p-4 text-center" data-id="element-106">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-107" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-108">
                <td className="p-4 font-semibold text-gray-900 border-r border-gray-100" data-id="element-109">
                  One-time cost
                </td>
                <td className="p-4 text-center bg-blue-50 border-x-2 border-blue-100" data-id="element-110">
                  <Check className="w-6 h-6 text-green-500 mx-auto stroke-[3px]" data-id="element-111" />
                </td>
                <td className="p-4 text-center" data-id="element-112">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-113" />
                </td>
                <td className="p-4 text-center" data-id="element-114">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-115" />
                </td>
                <td className="p-4 text-center" data-id="element-116">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-117" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-118">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-119">
            Common Concerns Answered
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-120">
            {[{
            objection: 'It looks uncomfortable',
            answer: "Actually, most people forget they're wearing it after 2–3 nights. The soft BPA-free material molds gently to your mouth."
          }, {
            objection: "It won't fit my mouth",
            answer: 'SnoreStop™ is heat-moldable and adjustable. One size fits 99% of mouths — no dentist visit needed.'
          }, {
            objection: "I'm afraid I'll choke",
            answer: "It doesn't block your breathing. It opens your airway so you breathe more freely, not less."
          }, {
            objection: 'I already tried other things',
            answer: "That's exactly why SnoreStop™ exists. Sprays, pillows, nose strips and apps don't fix airway collapse."
          }, {
            objection: 'This feels like another scam',
            answer: "Try it for 90 nights. If it doesn't reduce your snoring, you get a full refund. No forms. No arguments. No BS."
          }].map((item, i) => <div key={i} className="bg-gray-50 rounded-lg p-5 border border-gray-100" data-id="element-121">
                <p className="font-bold text-gray-900 mb-2 flex items-start" data-id="element-122">
                  <X className="w-5 h-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-123" />
                  "{item.objection}"
                </p>
                <p className="text-gray-700 ml-7" data-id="element-124">{item.answer}</p>
              </div>)}
          </div>
        </div>
      </Container>
    </section>;
}